import { httpsCallable } from 'firebase/functions';
import { functions } from '../Firebase';

export async function requestAnalyticsUpdate(
  accountId: string,
  scope: 'account' | 'campaign',
  dynamicPageId?: string,
): Promise<any> {
  const fn = httpsCallable(functions, 'analytics-refresh');

  const response = await fn({
    accountId,
    scope,
    ...(dynamicPageId ? { campaignId: dynamicPageId } : {}),
  });

  return response.data;
}

export async function getAnalyticsByDates(
  accountId: string,
  scope: 'account' | 'campaign',
  dynamicPageId: string | undefined,
  startDate: string,
  endDate: string,
): Promise<any> {
  const fn = httpsCallable(functions, 'analytics-analyticsByDates');

  const response = await fn({
    accountId,
    scope,
    ...(dynamicPageId ? { campaignId: dynamicPageId } : {}),
    startDate,
    endDate,
  });

  return response.data;
}

export async function getWebsiteOnViewAnalytics(
  accountId: string,
  dynamicPageId: string,
  websiteId: string,
  startDate?: string,
  endDate?: string,
): Promise<any> {
  const fn = httpsCallable(functions, 'analytics-websiteOnViewAnalytics');

  const response = await fn({
    accountId,
    ...(dynamicPageId ? { campaignId: dynamicPageId } : {}),
    websiteId,
    startDate,
    endDate,
  });

  return response.data;
}

export async function getExternalAnalyticsByDates(
  accountId: string,
  dynamicPageId: string | undefined,
  startDate: string,
  endDate: string,
): Promise<any> {
  const fn = httpsCallable(functions, 'analytics-externalAnalyticsByDates');

  const response = await fn({
    accountId,
    ...(dynamicPageId ? { campaignId: dynamicPageId } : {}),
    startDate,
    endDate,
  });

  return response.data;
}

export async function exportAnalytics(
  accountId: string,
  filter: Record<string, any>,
  metrics: { value: string; title: string }[],
  groupBy: { value: string; title: string }[],
  segments: { value: string; title: string }[],
  startDate: string,
  endDate: string,
): Promise<{
  ok: boolean;
  jobId: string;
  fileName: string;
}> {
  const fn = httpsCallable<
    {
      accountId: string;
      filter: Record<string, any>;
      metrics: { value: string; title: string }[];
      groupBy: { value: string; title: string }[];
      segments: { value: string; title: string }[];
      startDate: string;
      endDate: string;
    },
    {
      ok: boolean;
      jobId: string;
      fileName: string;
    }
  >(functions, 'analytics-exportAnalytics');

  const response = await fn({
    accountId,
    filter,
    metrics,
    groupBy,
    segments,
    startDate,
    endDate,
  });

  return response.data;
}
